import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('karvaTechUser');
    const token = localStorage.getItem('karvaTechToken');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const requestOtp = async (email, role = 'employee') => {
    try {
      const res = await axios.post(`${API_URL}/auth/request-otp`, { email, role });
      return res.data;
    } catch (err) {
      console.error('requestOtp error', err?.response || err);
      throw err;
    }
  };

  const verifyOtp = async (email, code, name) => {
    try {
      const res = await axios.post(`${API_URL}/auth/verify-otp`, { email, code, name });
      const { token, user: userData } = res.data;
      if (token) {
        localStorage.setItem('karvaTechToken', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
      if (userData) {
        setUser(userData);
        localStorage.setItem('karvaTechUser', JSON.stringify(userData));
      }
      return res.data;
    } catch (err) {
      console.error('verifyOtp error', err?.response || err);
      throw err;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('karvaTechUser');
    localStorage.removeItem('karvaTechToken');
    delete axios.defaults.headers.common['Authorization'];
  };

  const value = {
    user,
    requestOtp,
    verifyOtp,
    logout,
    loading,
    isAdmin: user?.role === 'admin',
    isEmployee: user?.role === 'employee',
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};